export const Marquee = () => {
  const items = [
    "3-STAGE PAINT CORRECTION",
    "CERAMIC COATING",
    "PPF · CLEAR & COLOURED",
    "VINYL WRAPPING",
    "INTERIOR DETAIL",
    "HEADLIGHT RESTORE",
    "ENGINE BAY",
    "HAND WASH & WAX",
  ];
  const row = [...items, ...items, ...items];
  return (
    <div
      data-testid="marquee-strip"
      className="bg-[#DC2626] py-5 overflow-hidden border-y border-black/20"
    >
      <div className="marquee-track">
        {row.map((t, i) => (
          <span
            key={i}
            className="font-display font-bold uppercase text-white text-2xl md:text-3xl tracking-wider mx-8 flex items-center gap-8"
          >
            {t}
            <span className="inline-block w-2 h-2 bg-white rotate-45" />
          </span>
        ))}
      </div>
    </div>
  );
};
